import { server } from "@/api";

export const show = async () => {
    return await server().get('api/settings');
}

export const update = async (formData) => {
    // formData is a FormData instance (may contain logo files).
    // Setting Content-Type to undefined lets axios attach the multipart boundary.
    return await server().post('api/settings', formData, {
        headers: { 'Content-Type': undefined },
    });
}

export const updatePassword = async (payload) => {
    return await server().post('api/settings/password', payload);
}

export const branding = async () => {
    return await server().get('api/branding');
}

export default { show, update, updatePassword, branding };
